import { render, staticRenderFns } from "./MainContact.vue?vue&type=template&id=3a00b5d5&"
import script from "./MainContact.vue?vue&type=script&lang=js&"
export * from "./MainContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports